import React from "react";
import { Grid, Typography, Stack} from "@mui/material";

function PageMidOneElements(props) {
    return ( 
        <>
        {/* Grid Item with Image */}
        <Grid alignItems={'center'} my={0} container spacing={2}>
        <Grid item xs={12} md={6} sm={6} lg={6} xl={6}>
          <Stack component='img' alt={props.alt} src={props.img} style={{ width: '100%' }} />      
        </Grid>

        {/* Grid Item with Text */}
        <Grid item xs={12} md={6} sm={6} lg={6} xl={6}>
            <Typography fontFamily={'Ruwudu, serif'} variant='h4' sx={{ textAlign: 'center'}}> {props.text} </Typography>
            <Typography fontFamily={'Roboto, sans-serif'} variant='h6' sx={{ textAlign: 'center'}}> {props.text2} </Typography>  
        </Grid>
      </Grid>

    {/* SEGUNDO ELEMENTO */}
      {/* Grid Item with Text */}
      <Grid alignItems={'center'} my={0} container spacing={2}>
        
        <Grid item xs={12} md={6} sm={6} lg={6} xl={6}>
            <Typography fontFamily={'Ruwudu, serif'} variant='h4' sx={{ textAlign: 'center'}}> {props.text3} </Typography>
            <Typography fontFamily={'Roboto, sans-serif'} variant='h6' sx={{ textAlign: 'center'}}> {props.text4} </Typography>
        </Grid>

        {/* Grid Item with Image */}
        <Grid item xs={12} md={6} sm={6} lg={6} xl={6}>
          <Stack component='img' alt={props.alt} src={props.img2} style={{ width: '100%' }} />     
        </Grid>  
      </Grid>

      </>           
    );
};
export default PageMidOneElements;